import { Loader2 } from "lucide-react";

export const API = process.env.REACT_APP_BACKEND_URL;

export const apiFetch = async (path, options = {}) => fetch(`${API}/api/admin/agent-os${path}`, { credentials: "include", ...options });

export const formatDateTime = (iso) => iso ? new Date(iso).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "—";

export const STATUS_STYLES = {
    draft: "border-ink/20 bg-ink/[0.04] text-ink/50",
    testing: "border-champagne/60 bg-champagne/10 text-[#8a7320]",
    active: "border-forest/40 bg-forest/10 text-forest",
    paused: "border-ink/20 bg-sand text-ink/55",
    disabled: "border-ink/15 bg-ink/[0.03] text-ink/40",
    suspended: "border-red-900/20 bg-red-900/5 text-red-900",
    queued: "border-ink/20 bg-sand text-ink/55",
    running: "border-champagne/60 bg-champagne/10 text-[#8a7320]",
    waiting_approval: "border-champagne/60 bg-champagne/10 text-[#8a7320]",
    completed: "border-forest/40 bg-forest/10 text-forest",
    failed: "border-red-900/20 bg-red-900/5 text-red-900",
    dead: "border-red-900/30 bg-red-900/10 text-red-900",
    pending: "border-champagne/60 bg-champagne/10 text-[#8a7320]",
    approved: "border-forest/40 bg-forest/10 text-forest",
    rejected: "border-red-900/20 bg-red-900/5 text-red-900",
};

export const RISK_STYLES = {
    low: "border-forest/30 bg-forest/5 text-forest",
    medium: "border-champagne/60 bg-champagne/10 text-[#8a7320]",
    high: "border-red-900/25 bg-red-900/5 text-red-900",
    critical: "border-red-900 bg-red-900 text-ivory",
};

export const Pill = ({ value, risk = false }) => (
    <span data-testid={`pill-${value}`} className={`inline-flex w-fit border px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.16em] ${(risk ? RISK_STYLES : STATUS_STYLES)[value] || "border-ink/15 text-ink/45"}`}>
        {String(value || "unknown").replace(/_/g, " ")}
    </span>
);

export const inputClass = "w-full border border-ink/15 bg-ivory px-4 py-3 text-sm text-ink outline-none transition-colors focus:border-forest";

export const Label = ({ children, dark = false }) => <span className={`mb-1.5 block text-[11px] font-medium uppercase tracking-[0.16em] ${dark ? "text-ivory/55" : "text-ink/55"}`}>{children}</span>;

export const Empty = ({ title, copy }) => (
    <div data-testid="agent-os-empty" className="border border-dashed border-ink/20 bg-sand/70 px-6 py-14 text-center">
        <p className="font-serif text-2xl font-medium">{title}</p>
        <p className="mx-auto mt-2 max-w-md text-sm text-ink/55">{copy}</p>
    </div>
);

export const Spinner = () => <div className="flex justify-center py-20"><Loader2 className="animate-spin text-forest" size={22} /></div>;

export const JsonPreview = ({ value }) => (
    <pre className="max-h-64 overflow-auto bg-night p-4 text-xs leading-relaxed text-ivory/75">{JSON.stringify(value, null, 2)}</pre>
);
